var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../../AppState';
/**
 * One Platform update quote.
 *
 * @param {Quote} quote
 *   The quote object obtained via One Platform.
 * @param {ProductOfferingObject} productOffering
 *   The product offering object.
 * @param {string} actionObjectId
 *   The action object ID of the selected plan.
 * @param {Promotion|boolean} promotions
 *   The promotion object.
 * @return {Promise<Quote>}
 *   An object containing the quote object.
 * @throws {Error}
 *   If there is an error with updating the quote.
 */
const onePlatformQuoteUpdate = (quote, productOffering, actionObjectId, promotions) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { onePlatformApiRoot, onePlatformApiClientId, onePlatformApiClientSecret, onePlatformApiQuote } = settings;
    const quoteEndpoint = onePlatformApiRoot + onePlatformApiQuote + '/' + quote.id;
    const nbnPlans = quote.ui.filter((uiItem) => uiItem.type && uiItem.type.toLowerCase() === 'data_subscription_specification');
    const modems = quote.ui.filter((uiItem) => uiItem.type && uiItem.type.toLowerCase() === 'modem_specification');
    const mappedPlans = nbnPlans.map((plan) => ({
        'action': plan.quoteItemPrice[0].price.attributes.find((attribute) => attribute.name === 'Recurring_RPC_ID' && attribute.value === actionObjectId) ? 'add' : 'delete',
        'elementGuid': plan.elementGuid,
        'parentElementGuid': plan.parentElementGuid,
    }));
    const mappedModems = modems.map((modem) => {
        var _a, _b;
        return ({
            'action': (((_b = (_a = modem === null || modem === void 0 ? void 0 : modem.digitalUIMarketing[0]) === null || _a === void 0 ? void 0 : _a.productName) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'DODO MODEM') ? 'add' : 'delete',
            'elementGuid': modem.elementGuid,
            'parentElementGuid': modem.parentElementGuid,
        });
    });
    const currentSelections = [...mappedPlans, ...mappedModems];
    if (typeof promotions !== 'boolean') {
        promotions.forEach(function (promotion) {
            currentSelections.push({
                'action': 'add',
                'elementGuid': promotion.elementGuid,
                'parentElementGuid': promotion.parentElementGuid,
            });
        });
    }
    // Remove mass market discount if other promotions are added.
    const validPromoData = AppState.get('onePlatformData.validPromoData');
    const promoCode = AppState.get('onePlatformData.promoCode');
    const isPromoCodeAndValidDataExists = promoCode && validPromoData && typeof validPromoData !== 'boolean';
    if (isPromoCodeAndValidDataExists) {
        const massMarketDiscount = quote.ui.find((uiItem) => uiItem.type === 'Discount_Product_Specification' && uiItem.selected === 'true');
        if (typeof massMarketDiscount !== 'undefined') {
            currentSelections.push({
                'action': 'delete',
                'elementGuid': massMarketDiscount.elementGuid,
                'parentElementGuid': massMarketDiscount.parentElementGuid,
            });
        }
    }
    currentSelections.push({
        'action': 'add',
        'exclusive': 'true'
    });
    const quotePayloadDataBuild = {
        'currentSelection': quote.followedRequest.currentSelection,
        'currentSelections': currentSelections,
        'currentValidation': quote.followedRequest.currentValidation,
        'itemAction': 'add',
        'metaDataLookup': quote.followedRequest.metaDataLookup,
        'productCandidate': quote.followedRequest.productCandidate,
        'productId': productOffering[0].productOffering[0].id,
        'quoteItemId': quote.followedRequest.quoteItemId,
        'quoteLastUpdated': quote.followedRequest.quoteLastUpdated,
    };
    const quotePayloadData = JSON.stringify(quotePayloadDataBuild);
    return fetch(quoteEndpoint, {
        method: 'put',
        headers: {
            'client_id': onePlatformApiClientId,
            'client_secret': onePlatformApiClientSecret,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: quotePayloadData,
    })
        .then((response) => __awaiter(void 0, void 0, void 0, function* () {
        if (!response.ok) {
            throw new Error('onePlatformQuoteUpdate error.');
        }
        else {
            return yield response.json();
        }
    }));
});
export default onePlatformQuoteUpdate;
